import React, {useEffect, useState} from 'react';
import {useLanguageStore} from "../../store/languageStore";

const JidarHeroSlider = ({data}) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	
	
	const {language} = useLanguageStore()
	const isArabic = language === 'ar';
	
	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentSlide((prevSlide) => (prevSlide + 1) % data.length);
		}, 5000);
		
		return () => clearInterval(interval);
	}, [data.length]);
	
	const goToSlide = (index) => {
		setCurrentSlide(index);
	};
	
	const nextSlide = () => {
		setCurrentSlide((prevSlide) => (prevSlide + 1) % data.length);
	};
	
	const prevSlide = () => {
		setCurrentSlide((prevSlide) => (prevSlide - 1 + data.length) % data.length);
	};
	
	return (<div className="relative w-full h-[95vh] overflow-hidden">
		{data.map((slide, index) => (<div
			key={slide.id}
			className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0 pointer-events-none"}`}
		>
			<div
				className="absolute inset-0 bg-center bg-cover bg-no-repeat"
				style={{
					backgroundImage: `url(${slide.image})`,
				}}
			>
				<div className="absolute inset-0 bg-black bg-opacity-40"></div>
			</div>
			
			<div
				className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
				<h1 className="text-5xl md:text-7xl font-bold mb-4 ">{isArabic ? slide.title_ar : slide.title_en}</h1>
				<p className="text-xl md:text-2xl mb-8 ">{isArabic ? slide.description_ar : slide.description_en}</p>
				<a href={slide.link}>
					<button
						className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-md transition-colors">
						{isArabic ? "المزيد" : "Learn More"}
					</button>
				</a>
			</div>
		</div>))}
		
		{/* Navigation Arrows */}
		<button
			className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-30 hover:bg-opacity-50 text-white p-2 rounded-full"
			onClick={prevSlide}
		>
			<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
			     stroke="currentColor">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7"/>
			</svg>
		</button>
		
		<button
			className="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-30 hover:bg-opacity-50 text-white p-2 rounded-full"
			onClick={nextSlide}
		>
			<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
			     stroke="currentColor">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7"/>
			</svg>
		</button>
		
		{/* Dots Indicator */}
		<div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
			{data.map((_, index) => (<button
				key={index}
				onClick={() => goToSlide(index)}
				className={`w-3 h-3 rounded-full transition-all ${currentSlide === index ? "bg-white w-6" : "bg-white bg-opacity-50"}`}
			/>))}
		</div>
	</div>);
};

export default JidarHeroSlider;